<template>
  <section class="upload-img-btn text-center relative inline-block">
    <input
      type="file"
      :data-test="`upload-img-${label}`"
      class="absolute left0 upload-file-input click-disabled"
      @change="uploadFile"
      :id="label"
    />

    <span
      v-if="isFile"
      :data-test="`remove-img-${label}`"
      class="remove absolute z1 pointer"
      @click="removeFile"
    >
      <svg
        width="26px"
        height="25px"
        viewBox="0 0 26 25"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g
          id="Page-1"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <path
            d="M12.9485294,1 C16.2420508,1 19.0568204,2.12131232 21.3929228,4.36397059 C23.7290252,6.60662886 24.8970588,9.30880772 24.8970588,12.4705882 C24.8970588,15.6323687 23.7290252,18.3345476 21.3929228,20.5772059 C19.0568204,22.8198642 16.2420508,23.9411765 12.9485294,23.9411765 C9.65500804,23.9411765 6.8402384,22.8198642 4.50413603,20.5772059 C2.16803366,18.3345476 1,15.6323687 1,12.4705882 C1,9.30880772 2.16803366,6.60662886 4.50413603,4.36397059 C6.8402384,2.12131232 9.65500804,1 12.9485294,1 Z"
            id="Path"
            stroke="#000000"
            fill="#FFFFFF"
            fill-rule="nonzero"
          ></path>
          <polygon
            id="Path"
            fill="#000000"
            fill-rule="nonzero"
            points="18.4632353 17.1029412 17.7738971 17.7647059 12.9485294 13.1323529 8.12316176 17.7647059 7.43382353 17.1029412 12.2591912 12.4705882 7.43382353 7.83823529 8.12316176 7.17647059 12.9485294 11.8088235 17.7738971 7.17647059 18.4632353 7.83823529 13.6378676 12.4705882"
          ></polygon>
        </g>
      </svg>
    </span>

    <figure v-if="isFile" class="relative mauto">
      <img v-if="isImg" class="w100" ref="imgPreview" />
      <img v-else class="opa4" src="../assets/note.svg" alt="" />
    </figure>

    <label v-else class="flex-center mauto" :for="label">
      <i>
        <svg
          width="31px"
          height="28px"
          viewBox="0 0 31 28"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="Page-1"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <path
              d="M15.68,23.2160577 C17.0501992,23.2160577 18.3122058,22.8795226 19.4660577,22.2064423 C20.6199096,21.533362 21.533362,20.6199096 22.2064423,19.4660577 C22.8795226,18.3122058 23.2160577,17.0501992 23.2160577,15.68 C23.2160577,14.3098008 22.8795226,13.0477942 22.2064423,11.8939423 C21.533362,10.7400904 20.6199096,9.82663798 19.4660577,9.15355769 C18.3122058,8.4804774 17.0501992,8.14394231 15.68,8.14394231 C14.3098008,8.14394231 13.0477942,8.4804774 11.8939423,9.15355769 C10.7400904,9.82663798 9.82663798,10.7400904 9.15355769,11.8939423 C8.4804774,13.0477942 8.14394231,14.3098008 8.14394231,15.68 C8.14394231,17.0501992 8.4804774,18.3122058 9.15355769,19.4660577 C9.82663798,20.6199096 10.7400904,21.533362 11.8939423,22.2064423 C13.0477942,22.8795226 14.3098008,23.2160577 15.68,23.2160577 Z M11.1727885,0.68 L20.1872115,0.68 L22.9275962,3.63673077 L27.7232692,3.63673077 C28.540581,3.63673077 29.2376894,3.93720853 29.8146154,4.53817308 C30.3915413,5.13913762 30.68,5.84826514 30.68,6.66557692 L30.68,24.6944231 C30.68,25.5117349 30.3915413,26.2208624 29.8146154,26.8218269 C29.2376894,27.4227915 28.540581,27.7232692 27.7232692,27.7232692 L3.63673077,27.7232692 C2.81941899,27.7232692 2.12231058,27.4227915 1.54538462,26.8218269 C0.968458654,26.2208624 0.68,25.5117349 0.68,24.6944231 L0.68,6.66557692 C0.68,5.84826514 0.968458654,5.13913762 1.54538462,4.53817308 C2.12231058,3.93720853 2.81941899,3.63673077 3.63673077,3.63673077 L8.43240385,3.63673077 L11.1727885,0.68 Z M10.8843269,15.68 C10.8843269,14.8146111 11.1006709,14.0153402 11.5333654,13.2821635 C11.9660599,12.5489867 12.5489867,11.9660599 13.2821635,11.5333654 C14.0153402,11.1006709 14.8146111,10.8843269 15.68,10.8843269 C16.5453889,10.8843269 17.3446598,11.1006709 18.0778365,11.5333654 C18.8110133,11.9660599 19.3939401,12.5489867 19.8266346,13.2821635 C20.2593291,14.0153402 20.4756731,14.8146111 20.4756731,15.68 C20.4756731,16.5453889 20.2593291,17.3446598 19.8266346,18.0778365 C19.3939401,18.8110133 18.8110133,19.3939401 18.0778365,19.8266346 C17.3446598,20.2593291 16.5453889,20.4756731 15.68,20.4756731 C14.8146111,20.4756731 14.0153402,20.2593291 13.2821635,19.8266346 C12.5489867,19.3939401 11.9660599,18.8110133 11.5333654,18.0778365 C11.1006709,17.3446598 10.8843269,16.5453889 10.8843269,15.68 Z"
              id=""
              fill="#FFFFFF"
              fill-rule="nonzero"
            ></path>
          </g>
        </svg>
      </i>
    </label>

    <validation-provider v-if="required" rules="required" v-slot="{ errors }">
      <input type="text" v-model="imageModel" />
      <span :class="{ red: errors[0] }">{{ label }}</span>
    </validation-provider>

    <span v-else>{{ label }}</span>

    <span v-if="formatNotSupported" class="not-supported red">
      Format document nesuportat.
    </span>
  </section>
</template>

<script>
  export default {
    name: 'upload-img-btn',
    props: {
      label: {
        type: String,
        required: true
      },
      formats: {
        type: Array,
        required: false
      },
      required: {
        type: Boolean,
        required: false
      },
      img: {
        type: Object,
        required: false
      }
    },
    data () {
      return {
        isDelete: false,
        imageModel: undefined,
        isImg: false,
        imgName: undefined,
        acceptedFiles: [
          '.jpg',
          '.JPG',
          '.jpeg',
          '.png',
          '.bmp',
          '.gif',
          '.jfif',
          '.JFIF'
        ],
        formatNotSupported: false,
        isFile: false
      };
    },
    created () {
      this.imageModel = this.img ? 'isImg' : undefined;
      this.isImg = !!this.img && this.img.w;
      this.isFile = !!this.img;
    },
    mounted () {
      if (this.img && this.label !== 'document') {
        const copy = JSON.stringify(this.img);
        this.img.w &&
          (this.$refs.imgPreview.src = this.makePicUrl(JSON.parse(copy).name));
      }
      if (this.formats) {
        this.acceptedFiles = this.formats;
      }
    },
    methods: {
      makePicUrl (name) {
        const id = this.$router.currentRoute.params.id;
        return this.img ? `/history-imgs/${id}/thumb-${name}.png` : '';
      },
      uploadFile (ev) {
        this.imageModel = 'loaded';
        const file = ev.currentTarget.files[0];
        const re = /\.[0-9a-z]+$/i;
        const extension = file ? re.exec(file.name)[0] : undefined;
        if (this.acceptedFiles.includes(extension)) {
          this.isFile = true;
          this.imgName = `${this.label}${extension}`;
          this.isImg = [
            '.jpg',
            '.JPG',
            '.jpeg',
            '.png',
            '.bmp',
            '.gif'
          ].includes(extension);
          this.isImg && this.previewUploadedImage(file, extension);
          this.$emit('select-img', { picName: this.imgName, file });
          this.formatNotSupported = false;
        } else {
          // this.formatNotSupported = true
          this.imageModel = undefined;
          alert('Format fisier nesuportat.');
        }
      },
      previewUploadedImage (file, extension) {
        let reader = new FileReader();
        reader.onload = () => {
          let output = this.$refs.imgPreview;
          if (extension !== '.pdf') {
            output.src = reader.result;
          }
        };
        reader.readAsDataURL(file);
      },
      removeFile () {
        this.imageModel = undefined;
        this.isImg = false;
        this.isFile = false;
        this.$store.commit('REMOVE_IMG', {
          picName: this.img.name || this.imgName
        });
      }
    }
  };
</script>

<style lang="less">
  @import "../../src/assets/styles/mixin";
  @import "../../src/assets/styles/var";
  .upload-img-btn {
    .upload-file-input {
      opacity: 0;
      width: 0.1px;
      height: 0;
    }

    figure {
      .square(65px);
      overflow: hidden;
      img {
        border-radius: 3px;
      }
    }

    label {
      .circle(65px);
      outline: none;
      border: none;
      cursor: pointer;
      background-color: @main-purple;
      transition: background-color 0.1s ease-in-out;
      &:hover {
        background-color: darken(@main-purple, 20%, relative);
      }
    }

    .remove {
      right: -14px;
      top: -18px;
    }

    .opa4 {
      transform: scale(0.8);
    }

    .red {
      color: @red!important;
    }

    input {
      position: absolute;
      left: 0;
      width: 0.1px;
      height: 0;
      border: none;
      opacity: 0;
      visibility: hidden;
    }

    .not-supported {
      width: 100%;
      min-width: 150px;
      position: absolute;
    }
  }
</style>
